module.exports = __webpack_public_path__ + "static/img/jigou-wuhanguanggu-bottom.11acab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-wuhanguanggu-bottom.png
// module id = lc7l
// module chunks = 2